// Theme JavaScript

document.addEventListener('DOMContentLoaded', function() {
  // Mobile Menu Toggle
  const menuToggle = document.querySelector('.menu-toggle');
  const mainNav = document.querySelector('.main-nav');

  if (menuToggle && mainNav) {
    menuToggle.addEventListener('click', function() {
      const isOpen = mainNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Product Image Gallery
  const thumbnails = document.querySelectorAll('.thumbnail');
  const mainImage = document.querySelector('.product-main-image');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      if (!mainImage) return;
      mainImage.src = this.getAttribute('src');
      
      // Remove active state from all thumbnails
      thumbnails.forEach(t => t.style.borderColor = 'transparent');
      // Add active state to clicked thumbnail
      this.style.borderColor = 'var(--primary-color)';
    });
  });

  // Search Form
  const searchForm = document.querySelector('.search-form');
  if (searchForm) {
    searchForm.addEventListener('submit', function(e) {
      const query = this.querySelector('input[name="q"]').value.trim();
      if (!query) {
        e.preventDefault();
      }
    });
  }

  // Smooth Scroll Link
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href !== '#') {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  });
});

// Add CSS animations
const style = document.createElement('style');
style.textContent = `
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @keyframes slideOut {
    from {
      transform: translateX(0);
      opacity: 1;
    }
    to {
      transform: translateX(100%);
      opacity: 0;
    }
  }
`;
document.head.appendChild(style);
